// Cookie link
const COOKIE_POLICY = 'https://www.ooilgroup.com/cookiepolicy/Pages/cookie_policy.aspx';

// User Type
const TYPE_VENDOR = 'Vendor';
const TYPE_STAKEHOLDER = 'Stakeholder';
const USER_TYPE_VENDOR = 'ROLE_VENDOR';
const USER_TYPE_STAKEHOLDER = 'ROLE_STAKEHOLDER';
const USER_TYPE_ADMIN = 'ROLE_ADMIN';
const USER_TYPE_REGION_VENDOR = 'ROLE_REGION_VENDOR';

// Assessment Status
const ASSESSMENT_STATUS_SAVED = 'SAVED';
const ASSESSMENT_STATUS_CONFIRMED = 'CONFIRMED';

// Message String
const MESSAGE_CONFIRM_WARNING_TITLE = 'Confirm';
const MESSAGE_CONFIRM_WARNING_TEXT = 'If you confirm this assessment, it will be sent out and cannot be modified. Are you sure to confirm?';
const MESSAGE_DELETE_WARNING_TITLE = 'Delete Warning';
const MESSAGE_DELETE_WARNING_TEXT = 'Are you sure to delete this assessment?';
const MESSAGE_DELETE_SUCCESSFULLY = 'Delete successfully.';
const MESSAGE_DELETE_FAILED = 'Delete failed. Please try again.';
const MESSAGE_CONFIRM_SUCCESSFULLY = 'Confirm successfully.';
const MESSAGE_CONFIRM_FAILED = 'Confirm failed. Please try again.';
const MESSAGE_CONFIRM_DELETE_CACHE = 'You will delete all dictionary cache, discard and proceed?';
const MESSAGE_EXPORT_PDF_FAILED = 'Export failed! Please try again or check the data of template.';
const MESSAGE_SEND_REMIND_EMAIL_TEXT = 'System won\'t send reminder email to the stakeholders who have completed the survey. Are you sure to continue?'
const MESSAGE_SEND_REMIND_EMAIL_TEXT_CONFIRM = 'Are you sure to continue?';

// Answer status
const ANSWER_STATUS_SENT = 'SENT';
const ANSWER_STATUS_INPROGRESS = 'IN PROGRESS';
const ANSWER_STATUS_COMPLETED = 'COMPLETED';

// Sesssion Storage Key
const USER_TYPE = 'USER_TYPE';
const ASSESSMENT_TYPE = 'ASSESSMENT_TYPE';
const ANSWER_ASSESSMENT_ID = 'ANSWER_ASSESSMENT_ID';
const ASSESSMENT_ID = 'ASSESSMENT_ID';
const ACCESSSUCCEED_TYPE_ANSWER = 'Answer';
const ACCESSSUCCEED_TYPE_CLOSE = 'Close';
const ACCESSSUCCEED_TYPE_ACCESSDENIED = 'AccessDenied';
const VENDOR_PAGES_TEXT = '<VendorName>';
const STAKEHOLDER_PAGES_TEXT = '<StakeholderName>';
const FOOTTER_PAGE_TEXT = '<CURRENT_YEAR>';
const ASSESSMENT_SEARCH_CONDITIONS = 'assessmentSearchConditions';
const QUESTIONNAIRE_SEARCH_CONDITIONS = 'questionnaireSearchConditions';
const STAKEHOLDER_SEARCH_CONDITIONS = 'stakeholderSearchConditions';
const VENDOR_SEARCH_CONDITIONS = 'vendorSearchConditions';
const REGION_ACCOUNT_SEARCH_CONDITIONS = 'regionAccountSearchConditions';
const ASSESSMENT_KEY_CODE = 'ASSESSMENT_KEY_CODE';

// Validate information
const INPUT_EMAIL = 'Please input the email address!';
const ENTER_CORRECT_EMAIL = 'Please enter the correct email address!';
const INPUT_VENDOR_CODE = 'Please input the [Vendor Code] information';
const INPUT_VENDOR_NAME = 'Please input the [Vendor Name] information';
const INPUT_REGION = 'Please input the [Region] information';
const INPUT_APPLICANT = 'Please input the [Applicant] information';
const INPUT_COMPANY = 'Please input the [Company] information';
const INPUT_REQUIRED = 'Please select the [Required] information';
const INPUT_ORGANIZATION = 'Please input the [Organization] information';
const INPUT_NAME = 'Please input the [Name] information';
const INPUT_CORRECT_NAME = 'Please input the correct [Name] information';
const INPUT_ASSOCIATED_STAFF = 'Please input the [Associated Staff] information';
const INPUT_CATEGORY = 'Please select the [Category] information';
const INPUT_CATEGORY_CODE = 'Please input the [Category Code] information';
const INPUT_CATEGORY_NAME = 'Please input the [Category Name] information';
const INPUT_DICT_VALUE = 'Please input the [DictValue] information';
const INPUT_DICT_KEY = 'Please input the [DictKey] information';
const INPUT_DICT_CATEGORY = 'Please input the [Category] information';
const INPUT_SUBJECT_EN = 'Please input the [SubjectEn] information';
const INPUT_CONTENT_EN = 'Please input the [ContentEn] information';
const INPUT_EMAIL_TEMPLATE_TYPE = 'Please input the [Type] information';
const INPUT_ADMIN_TYPE = 'Please input the [AdminType] information';
const INPUT_DISPLAY_NAME = 'Please input the [DisplayName] information';
const INPUT_DOMAIN_ID = 'Please input the [DomainId] information';
const INPUT_CONTACT_PERSON = 'Please input the [Contact Person] information';
const INPUT_ACTIVE = 'Please input the [Active] information';

// Exception code
const POPUP_EXCEPTION_CODE = '02001';
const RESPONSE_SUCCESS_CODE = 'SUCCESS';
const RESPONSE_SYSTEMERROR_CODE = 'SYSTEM_ERROR';

// Alert message
const SELECT_NONE_LINE = 'Please select one line to modify!';
const SELECT_MULTIPLE_LINES = 'You can only select one line to modify!';
const SUBMIT_NO_FILE = 'Please choose one Excel file to upload!';
const SUBMIT_MULTIPLE_FILES = 'You can only choose one Excel file to upload!';
const SELECT_MUTILPLE_FILES = 'Can not support to upload more than one Excel file.';
const SELECT_DELETE = 'Are you sure to delete the selected ?';
const NO_SELECTED = 'No selected!';
const SAVE_SUCCEED = 'Save succeed!';
const UPLOAD_SUCCEED = 'Upload succeed!';
const MESSAGE_SECTION_WARNING_TEXT = 'User has not finished this section yet';
const RESEND_SUCCESSFULLY = 'Resend successfully!';
const SELECT_NONE_LINE_REMIND = 'Please select one line to remind!';

// Export pdf attribute
const EXPORT_PDF_FILE_NAME_VENDOR = 'VendorResultDetail';
const EXPORT_PDF_FILE_NAME_VENDOR_HISTORY = 'VendorResultDetailHistory';
const EXPORT_PDF_FILE_NAME_STAKEHOLDER = 'StakeholderResultDetail';
const EXPORT_TYPE_PDF = 'application/pdf';
const EXPORT_LINK_ATTRIBUTE = 'download';

// Section Type
const SECTION_TYPE_PEER_EVALUATION = 'Peer_Evaluation';
const SECTION_TYPE_LIMITMULTISELECTION = 'LimitMultiSelection';

const USER_NAME = 'userName';

// Language
const LANGUAGE = 'language';
const LANGUAGE_EN = 'EN';
const LANGUAGE_SC = 'SC';
const LANGUAGE_TC = 'TC';
const LANGUAGE_ALL = 'ALL';

// Excel column name
const VENDOR_EXCEL_HEADER = ['Year', 'Assessment Name', 'Vendor Code', 'Vendor Name', 'Email', 'Region', 'Applicant', 'Company', 'Status', 'Score'];
const VENDOR_EXCEL_CONTENT = ['year', 'assessmentNo', 'vendorCode', 'userName', 'email', 'region', 'applicant', 'company', 'status', 'score'];
const STAKEHOLDER_EXCEL_HEADER = ['Year', 'Assessment Name', 'Category', 'Organization', 'Region', 'Staff', 'Email', 'Company', 'Associated Staff', 'Status'];
const STAKEHOLDER_EXCEL_CONTENT = ['year', 'assessmentNo', 'category', 'organization', 'region', 'userName', 'email', 'company', 'applicant', 'status'];

// User guide url
const USER_GUIDE_URL = 'USER_GUIDE_URL';

const CONFIG_BUSINESS = 'CONFIG_BUSINESS';
const ASSESSMENT_ANSWER_GRADE_SCOPE = 'ASSESSMENT_ANSWER_GRADE_SCOPE';

const REDO_SUCCESS = 'The re-do email has been sent out successfully.';

export default {
  COOKIE_POLICY,
  ASSESSMENT_ID,
  RESEND_SUCCESSFULLY,
  TYPE_VENDOR,
  ASSESSMENT_STATUS_SAVED,
  TYPE_STAKEHOLDER,
  MESSAGE_DELETE_WARNING_TITLE,
  MESSAGE_DELETE_WARNING_TEXT,
  MESSAGE_CONFIRM_WARNING_TEXT,
  MESSAGE_CONFIRM_WARNING_TITLE,
  ASSESSMENT_STATUS_CONFIRMED,
  ANSWER_STATUS_SENT,
  ANSWER_STATUS_INPROGRESS,
  ANSWER_STATUS_COMPLETED,
  USER_TYPE,
  ANSWER_ASSESSMENT_ID,
  ACCESSSUCCEED_TYPE_ACCESSDENIED,
  ACCESSSUCCEED_TYPE_CLOSE,
  ACCESSSUCCEED_TYPE_ANSWER,
  STAKEHOLDER_PAGES_TEXT,
  VENDOR_PAGES_TEXT,
  POPUP_EXCEPTION_CODE,
  INPUT_EMAIL,
  ENTER_CORRECT_EMAIL,
  INPUT_VENDOR_CODE,
  INPUT_VENDOR_NAME,
  INPUT_REGION,
  INPUT_APPLICANT,
  INPUT_COMPANY,
  INPUT_REQUIRED,
  INPUT_ORGANIZATION,
  INPUT_NAME,
  INPUT_CORRECT_NAME,
  INPUT_ASSOCIATED_STAFF,
  INPUT_CATEGORY,
  FOOTTER_PAGE_TEXT,
  INPUT_CATEGORY_CODE,
  INPUT_CATEGORY_NAME,
  USER_TYPE_VENDOR,
  USER_TYPE_STAKEHOLDER,
  USER_TYPE_ADMIN,
  MESSAGE_SECTION_WARNING_TEXT,
  SELECT_NONE_LINE,
  SELECT_MULTIPLE_LINES,
  SUBMIT_NO_FILE,
  SUBMIT_MULTIPLE_FILES,
  SELECT_MUTILPLE_FILES,
  SELECT_DELETE,
  NO_SELECTED,
  SAVE_SUCCEED,
  EXPORT_PDF_FILE_NAME_STAKEHOLDER,
  EXPORT_PDF_FILE_NAME_VENDOR,
  EXPORT_PDF_FILE_NAME_VENDOR_HISTORY,
  EXPORT_TYPE_PDF,
  EXPORT_LINK_ATTRIBUTE,
  MESSAGE_DELETE_SUCCESSFULLY,
  MESSAGE_DELETE_FAILED,
  MESSAGE_CONFIRM_SUCCESSFULLY,
  MESSAGE_CONFIRM_FAILED,
  MESSAGE_CONFIRM_DELETE_CACHE,
  SECTION_TYPE_PEER_EVALUATION,
  USER_NAME,
  LANGUAGE_EN,
  LANGUAGE_SC,
  LANGUAGE_TC,
  LANGUAGE_ALL,
  LANGUAGE,
  ASSESSMENT_TYPE,
  SECTION_TYPE_LIMITMULTISELECTION,
  UPLOAD_SUCCEED,
  INPUT_DICT_VALUE,
  INPUT_DICT_KEY,
  INPUT_DICT_CATEGORY,
  INPUT_SUBJECT_EN,
  INPUT_CONTENT_EN,
  INPUT_EMAIL_TEMPLATE_TYPE,
  INPUT_ADMIN_TYPE,
  INPUT_DISPLAY_NAME,
  INPUT_DOMAIN_ID,
  ASSESSMENT_SEARCH_CONDITIONS,
  QUESTIONNAIRE_SEARCH_CONDITIONS,
  STAKEHOLDER_SEARCH_CONDITIONS,
  VENDOR_SEARCH_CONDITIONS,
  VENDOR_EXCEL_HEADER,
  VENDOR_EXCEL_CONTENT,
  STAKEHOLDER_EXCEL_HEADER,
  STAKEHOLDER_EXCEL_CONTENT,
  MESSAGE_EXPORT_PDF_FAILED,
  SELECT_NONE_LINE_REMIND,
  MESSAGE_SEND_REMIND_EMAIL_TEXT,
  MESSAGE_SEND_REMIND_EMAIL_TEXT_CONFIRM,
  USER_TYPE_REGION_VENDOR,
  REGION_ACCOUNT_SEARCH_CONDITIONS,
  INPUT_CONTACT_PERSON,
  INPUT_ACTIVE,
  ASSESSMENT_KEY_CODE,
  CONFIG_BUSINESS,
  ASSESSMENT_ANSWER_GRADE_SCOPE,
  REDO_SUCCESS,
  USER_GUIDE_URL,
  RESPONSE_SUCCESS_CODE,
  RESPONSE_SYSTEMERROR_CODE
}



// WEBPACK FOOTER //
// ./src/common/Constant.js